import localforage from 'localforage';
import { getLegacyStorageItem, removeLegacyStorageItem } from '@/shared/storageLocalLegacy';

const orderQueueStore = localforage.createInstance({
  name: 'PWA_RCA',
  storeName: 'order_queues',
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
});

const KEY_OFFLINE = 'offline_orders' as const;
const KEY_SYNCHED = 'synched_orders' as const;

const normalizeArray = (value: unknown): any[] => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return [];
};

async function readQueue(key: typeof KEY_OFFLINE | typeof KEY_SYNCHED): Promise<any[]> {
  const stored = await orderQueueStore.getItem<any[]>(key);
  if (stored !== null && stored !== undefined) {
    return normalizeArray(stored);
  }
  const legacy = getLegacyStorageItem(key);
  const normalized = normalizeArray(legacy);
  if (legacy !== null && legacy !== undefined) {
    await orderQueueStore.setItem(key, normalized);
    removeLegacyStorageItem(key);
    return normalized;
  }
  await orderQueueStore.setItem(key, []);
  return [];
}

export async function getOfflineOrders(): Promise<any[]> {
  return readQueue(KEY_OFFLINE);
}

export async function getSynchedOrders(): Promise<any[]> {
  return readQueue(KEY_SYNCHED);
}

export async function setOfflineOrders(data: any[]): Promise<boolean> {
  try {
    await orderQueueStore.setItem(KEY_OFFLINE, normalizeArray(data));
    try {
      removeLegacyStorageItem(KEY_OFFLINE);
    } catch {
      //
    }
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export async function setSynchedOrders(data: any[]): Promise<boolean> {
  try {
    await orderQueueStore.setItem(KEY_SYNCHED, normalizeArray(data));
    try {
      removeLegacyStorageItem(KEY_SYNCHED);
    } catch {
      //
    }
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
